






























import {Component, Prop, Vue} from 'vue-property-decorator';
import {
  fsStatusDiagramColorScheme as colorScheme,
  machineWorkingErrorTitles as titleSchemeError,
  machineWorkingStatusTitles as titleSchemeStatus,
  nodeStatusColorScheme,
  nodeStatusTitles,
} from '@/components/system/configurate';
import DiagramLegendNoCard from '@c/diagrams/DiagramLegendNoCard.vue';

@Component({
  components: {DiagramLegendNoCard},
})
export default class FacilityStructureTree extends Vue {
  @Prop()
  isSensorReadingPage!: boolean;

  menu = false;

  weekLegendData = [
    {color: colorScheme.week.error, name: titleSchemeError.error},
    {color: colorScheme.week.status.off, name: titleSchemeStatus.off},
    {color: colorScheme.week.status.idle, name: titleSchemeStatus.idle},
    {color: colorScheme.week.status.work, name: titleSchemeStatus.work},
    {color: colorScheme.week.status.incorrect, name: titleSchemeStatus.incorrect},
  ];

  statusLegendData = [
    {color: nodeStatusColorScheme.notAvailable, name: nodeStatusTitles.notAvailable},
    {color: nodeStatusColorScheme.bottomErrorBoundary, name: nodeStatusTitles.bottomErrorBoundary},
    {
      color: nodeStatusColorScheme.bottomDangerBoundary,
      name: nodeStatusTitles.bottomDangerBoundary,
    },
    {
      color: nodeStatusColorScheme.bottomWarningBoundary,
      name: nodeStatusTitles.bottomWarningBoundary,
    },
    {color: nodeStatusColorScheme.normal, name: nodeStatusTitles.normal},
    {color: nodeStatusColorScheme.topWarningBoundary, name: nodeStatusTitles.topWarningBoundary},
    {color: nodeStatusColorScheme.topDangerBoundary, name: nodeStatusTitles.topDangerBoundary},
    {color: nodeStatusColorScheme.topErrorBoundary, name: nodeStatusTitles.topErrorBoundary},
  ];
}
